// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"HeaderClientWrapper_headerWrapper__EC1aM"};